export default __webpack_public_path__ + "static/media/FSKoopman-LightItalic.7f0720e1.woff2";